<script setup>
/* eslint-disable */
import { computed } from 'vue';
import { useCurrenciesStore } from '@/stores/currencies';

const props = defineProps({
	isFocused: {
		type: Boolean,
		default: false
	}
});

defineEmits(['update', 'max']);

const currenciesStore = useCurrenciesStore();

const keypadValues = computed(() => currenciesStore.getKeypadValues || [500, 1000, 5000]);
const keypadValuesView = computed(() => currenciesStore.getKeypadValuesView || ['500', '1000', '5000']);
</script>

<template>
	<div class="amount-select-main" :class="{ system_bet_numpad: isFocused }">
		<div class="amount-select-outer">
			<div class="keypad-grid">
				<!-- Row 1 -->
				<div class="keypad-item" @click="$emit('update', 'append', 1)">
					<p>1</p>
				</div>
				<div class="keypad-item" @click="$emit('update', 'append', 2)">
					<p>2</p>
				</div>
				<div class="keypad-item" @click="$emit('update', 'append', 3)">
					<p>3</p>
				</div>
				<div class="keypad-item quick-add-item" @click="$emit('update', 'add', keypadValues[0])">
					<p>{{ keypadValuesView[0] }}</p>
				</div>

				<!-- Row 2 -->
				<div class="keypad-item" @click="$emit('update', 'append', 4)">
					<p>4</p>
				</div>
				<div class="keypad-item" @click="$emit('update', 'append', 5)">
					<p>5</p>
				</div>
				<div class="keypad-item" @click="$emit('update', 'append', 6)">
					<p>6</p>
				</div>
				<div class="keypad-item quick-add-item" @click="$emit('update', 'add', keypadValues[1])">
					<p>{{ keypadValuesView[1] }}</p>
				</div>

				<!-- Row 3 -->
				<div class="keypad-item" @click="$emit('update', 'append', 7)">
					<p>7</p>
				</div>
				<div class="keypad-item" @click="$emit('update', 'append', 8)">
					<p>8</p>
				</div>
				<div class="keypad-item" @click="$emit('update', 'append', 9)">
					<p>9</p>
				</div>
				<div class="keypad-item quick-add-item" @click="$emit('update', 'add', keypadValues[2])">
					<p>{{ keypadValuesView[2] }}</p>
				</div>

				<!-- Row 4 -->
				<div class="keypad-item decimal-item" @click="$emit('update', 'append', '.')">
					<p>.</p>
				</div>
				<div class="keypad-item" @click="$emit('update', 'append', 0)">
					<p>0</p>
				</div>
				<div class="keypad-item delete-item" @click="$emit('update', 'delete', 0)">
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="backspace-icon">
						<path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0 -2-2z"/>
						<line x1="18" y1="9" x2="12" y2="15"/>
						<line x1="12" y1="9" x2="18" y2="15"/>
					</svg>
				</div>
				<div class="keypad-item max-bet-item" @click="$emit('max')">
					<p>{{ $t('betslip.max_bet') }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.amount-select-main {
	padding: 4px 10px 8px;
	overflow: hidden;
	transition: 0.3s ease-in-out;
}

.amount-select-outer {
	width: 100%;
}

.keypad-grid {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 5px;
	width: 100%;
}

.keypad-item {
	background-color: var(--light-dark);
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 36px;
	cursor: pointer;
	transition: background-color 0.15s ease, transform 0.1s ease;
	user-select: none;
}

.keypad-item p {
	font-size: 15px;
	font-weight: 400;
	color: var(--white);
	margin: 0;
}

.keypad-item svg.backspace-icon {
	color: var(--white);
}

@media (any-pointer: fine) {
	.keypad-item:hover {
		background-color: #2b3d4f;
	}
}

.keypad-item:active {
	transform: scale(0.95);
	background-color: #26384a;
}

.keypad-item.max-bet-item {
	background-color: transparent;
	border: 1px solid var(--primary);
}

.keypad-item.max-bet-item p {
	color: var(--primary);
	font-size: 11.5px;
	font-weight: 500;
}

@media (any-pointer: fine) {
	.keypad-item.max-bet-item:hover {
		background-color: rgba(0, 200, 83, 0.08);
	}
}

.keypad-item.max-bet-item:active {
	background-color: rgba(0, 200, 83, 0.16);
}
</style>
